import { render, staticRenderFns } from "./AlertOnBoarding.vue?vue&type=template&id=2787eb4a&"
import script from "./AlertOnBoarding.vue?vue&type=script&lang=js&"
export * from "./AlertOnBoarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports